import { Building2, Users2, FileText, Settings2, Edit3 } from 'lucide-react';

export default function BusinessProfile() {
  return (
    <div className="space-y-8">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 bg-neutral-100 dark:bg-neutral-800 rounded-2xl flex items-center justify-center border border-neutral-200 dark:border-neutral-800">
            <Building2 className="w-8 h-8 text-neutral-400 dark:text-neutral-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Acme Corp</h1>
            <p className="text-neutral-500 dark:text-neutral-400 text-sm">Technology • Enterprise</p>
          </div>
        </div>
        <button className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-xl text-sm font-medium hover:bg-neutral-50 dark:hover:bg-neutral-950 transition-colors">
          <Edit3 className="w-4 h-4" />
          Edit Profile
        </button>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-6">
          <div className="bg-white dark:bg-neutral-900 p-8 rounded-[2rem] border border-neutral-200 dark:border-neutral-800 shadow-sm dark:shadow-none space-y-4">
            <h3 className="font-bold text-lg">Company Overview</h3>
            <p className="text-sm text-neutral-600 dark:text-neutral-300 leading-relaxed">
              Acme Corp is a leading provider of innovative technology solutions for global enterprises. We specialize in cloud computing, AI-driven analytics, and cybersecurity.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { label: 'Team Members', value: '18', icon: Users2 },
              { label: 'Documents', value: '42', icon: FileText },
              { label: 'Industry Rank', value: '#42', icon: Building2 },
              { label: 'Settings', value: 'Active', icon: Settings2 },
            ].map((item) => (
              <div key={item.label} className="bg-white dark:bg-neutral-900 p-6 rounded-2xl border border-neutral-200 dark:border-neutral-800 flex items-center gap-4">
                <div className="p-3 rounded-xl bg-neutral-50 dark:bg-neutral-950">
                  <item.icon className="w-5 h-5 text-neutral-600 dark:text-neutral-300" />
                </div>
                <div>
                  <p className="text-xs text-neutral-500 dark:text-neutral-400 font-bold uppercase tracking-widest">{item.label}</p>
                  <p className="text-lg font-bold">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-neutral-900 rounded-[2rem] p-8 text-white">
            <h3 className="font-bold mb-4">Team Management</h3>
            <p className="text-neutral-400 dark:text-neutral-500 text-xs mb-6">Manage your team members and their access levels.</p>
            <button className="w-full bg-white text-neutral-900 py-3 rounded-xl font-bold text-sm hover:bg-neutral-100 transition-colors">
              Invite Member
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
